import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { JsonLdModule } from 'ngx-seo';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { WindowRef } from './Window/WindowRef';
import { AuthInterceptor } from './http-interceptor/auth-interceptor';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { FooterTopComponent } from './layout/footer-top/footer-top.component';
import { FooterBottomComponent } from './layout/footer-bottom/footer-bottom.component';
import { HomeMainComponent } from './home/home-main/home-main.component';
import { BannerComponent } from './home/banner/banner.component';
import { TrendingPropertiesComponent } from './home/trending-properties/trending-properties.component';
import { WhyNepropComponent } from './home/why-neprop/why-neprop.component';
import { BlogsComponent } from './home/blogs/blogs.component';
import { MainComponent } from './advertisement/main/main.component';
import { Ad1Component } from './advertisement-steps/ad1/ad1.component';
import { Ad2Component } from './advertisement-steps/ad2/ad2.component';
import { Ad3Component } from './advertisement-steps/ad3/ad3.component';
import { Ad4Component } from './advertisement-steps/ad4/ad4.component';
import { Ad5Component } from './advertisement-steps/ad5/ad5.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ProfileComponent } from './profile/profile.component';
import { AddAdvertisementComponent } from './add-advertisement/add-advertisement.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { AboutComponent } from './about/about.component';
import { BlogComponent } from './blog/blog.component';
import { ContactComponent } from './contact/contact.component';
import { BasicInfoComponent } from './profile-pages/basic-info/basic-info.component';
import { FavouriteComponent } from './profile-pages/favourite/favourite.component';
import { MyPropertiesComponent } from './profile-pages/my-properties/my-properties.component';
import { EditPropertyComponent } from './edit-property/edit-property.component';
import { ChangePasswordComponent } from './profile-pages/change-password/change-password.component';
import { ChangePhoneComponent } from './profile-pages/change-phone/change-phone.component';
import { EditProperyTypeComponent } from './components/edit-propery-type/edit-propery-type.component';
import { EditLocationInfoComponent } from './components/edit-location-info/edit-location-info.component';
import { EditPropertyImagesComponent } from './components/edit-property-images/edit-property-images.component';
import { EditPropertyFacilitiesComponent } from './components/edit-property-facilities/edit-property-facilities.component';
import { BlogSinglePageComponent } from './blog-single-page/blog-single-page.component';
import { LocationComponent } from './location/location.component';
import { SearchLocationComponent } from './search-location/search-location.component';
import { EsewaPaymentSuccessComponent } from './esewa-payment-success/esewa-payment-success.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PaymentComponent } from './payment/payment.component';
import { PublishedPropertyComponent } from './profile-pages/published-property/published-property.component';
import { BankPaymentComponent } from './components/bank-payment/bank-payment.component';
import { BankTransferComponent } from './components/bank-transfer/bank-transfer.component';
import { RoadBlockComponent } from './components/road-block/road-block.component';
import { PropertiesComponent } from './properties/properties.component';
import { ExpiredPropertiesComponent } from './profile-pages/expired-properties/expired-properties.component';
import { TosComponent } from './tos/tos.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ManagementComponent } from './management/management.component';
import { PropertyAdminPreviewComponent } from './property-admin-preview/property-admin-preview.component';
import { ImagePreviewComponent } from './components/image-preview/image-preview.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OurServicesComponent } from './our-services/our-services.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FeaturesComponent } from './home/features/features.component';
import { ConfirmationBoxComponent } from './components/confirmation-box/confirmation-box.component';
import { RequestPasswordChangeComponent } from './request-password-change/request-password-change.component';
import { ChangePasswordTokenComponent } from './change-password-token/change-password-token.component';
import { PricingComponent } from './pricing/pricing.component';
import { EditPropertyPaymentComponent } from './components/edit-property-payment/edit-property-payment.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    FooterTopComponent,
    FooterBottomComponent,
    HomeMainComponent,
    BannerComponent,
    TrendingPropertiesComponent,
    WhyNepropComponent,
    BlogsComponent,
    MainComponent,
    Ad1Component,
    Ad2Component,
    Ad3Component,
    Ad4Component,
    Ad5Component,
    LoginComponent,
    RegisterComponent,
    ProfileComponent,
    AddAdvertisementComponent,
    SearchResultComponent,
    PhoneVerificationComponent,
    AboutComponent,
    BlogComponent,
    ContactComponent,
    BasicInfoComponent,
    FavouriteComponent,
    MyPropertiesComponent,
    EditPropertyComponent,
    ChangePasswordComponent,
    ChangePhoneComponent,
    EditProperyTypeComponent,
    EditLocationInfoComponent,
    EditPropertyImagesComponent,
    EditPropertyFacilitiesComponent,
    BlogSinglePageComponent,
    LocationComponent,
    SearchLocationComponent,
    EsewaPaymentSuccessComponent,
    NotFoundComponent,
    PaymentComponent,
    PublishedPropertyComponent,
    BankPaymentComponent,
    BankTransferComponent,
    RoadBlockComponent,
    PropertiesComponent,
    ExpiredPropertiesComponent,
    TosComponent,
    PrivacyComponent,
    ManagementComponent,
    PropertyAdminPreviewComponent,
    ImagePreviewComponent,
    OurServicesComponent,
    LoginRegisterComponent,
    FeaturesComponent,
    ConfirmationBoxComponent,
    RequestPasswordChangeComponent,
    ChangePasswordTokenComponent,
    PricingComponent,
    EditPropertyPaymentComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxGalleryModule,
    AngularEditorModule,
    SlickCarouselModule,
    JsonLdModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatDialogModule,
    MatMenuModule,
    MatTabsModule
  ],
  providers: [
    HttpClientModule,
    WindowRef,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
